import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "country-item-list__collapse-header" }
const _hoisted_2 = { class: "country-item-list__collapse-text" }
const _hoisted_3 = { class: "country-item-list__region-count" }
const _hoisted_4 = {
  key: 0,
  class: "country-item-list__collapse-hint"
}
const _hoisted_5 = {
  key: 0,
  class: "country-item-list__collapse-price"
}
const _hoisted_6 = { class: "country-item-list__collapse-price-hint" }


import type { BestOfferForRegion } from '@/interfaces/api/v1-best-offer-for-region';
import { TOTAL_PRICE_TEXT_REGION, NBSP } from '@global-js/constants';
import BasePrice from '@lmt-rpb/Atoms/BasePrice/BasePrice.vue';

interface Props {
	region: BestOfferForRegion & { code: string };
	isOpen: boolean;
	bestPrices: Record<string, number>;
	getRegionsCount: (regions: BestOfferForRegion['Regions']) => string;
	collapseHintText: (regions: BestOfferForRegion['Regions']) => string;
	formatPrice: (price: number) => string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CountryItemListHeader',
  props: {
    region: {},
    isOpen: { type: Boolean },
    bestPrices: {},
    getRegionsCount: { type: Function },
    collapseHintText: { type: Function },
    formatPrice: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['country-item-list__collapse-title', { 'country-item-list__collapse-title--open': _ctx.isOpen }])
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.region.RegionGroupName) + " ", 1 /* TEXT */),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getRegionsCount(_ctx.region.Regions)), 1 /* TEXT */)
      ]),
      (!_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.collapseHintText(_ctx.region.Regions)), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (!_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(TOTAL_PRICE_TEXT_REGION)), 1 /* TEXT */),
          _createTextVNode(" " + _toDisplayString(_unref(NBSP)), 1 /* TEXT */),
          _createVNode(BasePrice, {
            price: _ctx.bestPrices[_ctx.region.code]
          }, null, 8 /* PROPS */, ["price"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})